import { render, staticRenderFns } from "./IndexClientBonus.vue?vue&type=template&id=812cd750"
import script from "./IndexClientBonus.vue?vue&type=script&lang=js"
export * from "./IndexClientBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports